import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// Import Containers
import {
    FullLayoutComponent,
    SimpleLayoutComponent
} from './containers';
import { MainView } from 'app/views/main/main.component';
import { InputView } from 'app/views/input/input.component';
import { ListView } from 'app/views/list/list.component';
import { DetailView } from 'app/views/detail/detail.component';
import { ClassificationView } from 'app/views/setting/classification.component';
import { UserView } from 'app/views/setting/user.component';
import { DisplayView } from 'app/views/display/display.component';
import { P500View } from 'app/views/pages/500.component';
import { P404View } from 'app/views/pages/404.component';
import { P403View } from 'app/views/pages/403.component';
import { P401View } from 'app/views/pages/401.component';
import { LoginView } from 'app/views/pages/login.component';
import { RedirectView } from 'app/views/pages/redirect.component';
import { NotificationView } from 'app/views/setting/notification.component';

export const routes: Routes = [
    {
        path: '',
        redirectTo: 'main',
        pathMatch: 'full',
    },
    {
        path: '',
        component: FullLayoutComponent,
        data: {
            title: 'Home'
        },
        children: [
            {
                path: 'main',
                component: MainView,
                data: {
                    title: '目安箱システム'
                }
            },
            {
                path: 'input',
                component: InputView,
                data: {
                    title: '相談入力 - 目安箱システム'
                }
            },
            {
                path: 'list',
                component: ListView,
                data: {
                    title: '相談一覧 - 目安箱システム'
                }
            },
            {
                path: 'detail/:referenceNum',
                component: DetailView,
                data: {
                    title: '相談情報確認 - 目安箱システム'
                }
            },
            {
                path: 'display/:referenceNum',
                component: DisplayView,
                data: {
                    title: '相談情報参照 - 目安箱システム'
                }
            },
            {
                path: 'setting/classification',
                component: ClassificationView,
                data: {
                    title: 'マスタメンテ - 目安箱システム'
                }
            },
            {
                path: 'setting/notification',
                component: NotificationView,
                data: {
                    title: 'お知らせ管理 - 目安箱システム'
                }
            },
            {
                path: 'setting/user',
                component: UserView,
                data: {
                    title: 'ユーザ管理 - 目安箱システム'
                }
            }
        ]
    },
    {
        path: 'pages',
        component: SimpleLayoutComponent,
        data: {
            title: 'Pages'
        },
        children: [
            {
                path: '500',
                component: P500View,
                data: {
                    title: '500 - 目安箱システム'
                }
            },
            {
                path: '404',
                component: P404View,
                data: {
                    title: '404 - 目安箱システム'
                }
            },
            {
                path: '403',
                component: P403View,
                data: {
                    title: '403 - 目安箱システム'
                }
            },
            {
                path: '401',
                component: P401View,
                data: {
                    title: '401 - 目安箱システム'
                }
            },
            {
                path: 'login',
                component: LoginView,
                data: {
                    title: 'ログイン - 目安箱システム'
                }
            },
            {
                path: 'redirect',
                component: RedirectView,
                data: {
                    title: 'redirect - 目安箱システム'
                }
            }
        ]
    }

];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule { }



// WEBPACK FOOTER //
// E:/02_workspace/TenneT/git/tennet_suggestion_box/client/src/app/app.routing.ts